export const guidRegexp = /^[0-9a-f]{8}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{12}$/i;

export const telPrefix = 'tel:';
export const sipPrefix = 'sip:';
export const voicemailPostfix = ';opaque=app:voicemail;local-resource-path=voicememo';

export const contactWidgetStateViewTypeKey = 'Nimbus.AttendantConsole.ContactWidgetState.ViewType';
export const contactWidgetStateSearchTextKey = 'Nimbus.AttendantConsole.ContactWidgetState.SearchText';
export const contactWidgetStateSearchFilterValueKey = 'Nimbus.AttendantConsole.ContactWidgetState.SearchFilterValue';
export const contactWidgetStateContactGroupIdKey = 'Nimbus.AttendantConsole.ContactWidgetState.ContactGroupId';
export const isQueueCollapsedStorageKey = 'Nimbus.AttendantConsole.General.IsQueueCollapsed';
export const isDetailsPinnedStorageKey = 'Nimbus.AttendantConsole.General.IsDetailsPinned';
export const taskHeightStorageKey = 'Nimbus.AttendantConsole.General.TaskHeight';
export const dividerStateStorageKey = 'Nimbus.AttendantConsole.General.DividerState';
export const parkedSortOrderStorageKey = 'Nimbus.AttendantConsole.Parked.SortOrder';
